module.exports = __webpack_public_path__ + "fonts/51bd83f64ea34b95a015e276bc3453e7.svg";